import { useEffect } from "react";

// Points the browser tab icon at `href` (the session's setting.branding.smlogo) while
// mounted. Empty `href` or unmount restores whatever index.html declared.
export default function useFavicon(href) {
  useEffect(() => {
    if (!href || typeof document === "undefined") return undefined;
    let link = document.querySelector('link[rel~="icon"]');
    const created = !link;
    if (created) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    const prevHref = link.getAttribute("href");
    const prevType = link.getAttribute("type");
    link.setAttribute("href", href);
    // index.html declares type="image/svg+xml"; a PNG/JPG logo under that type can be
    // skipped by the browser, so let it sniff the real type instead.
    link.removeAttribute("type");
    return () => {
      if (created) {
        link.remove();
        return;
      }
      if (prevHref === null) link.removeAttribute("href");
      else link.setAttribute("href", prevHref);
      if (prevType !== null) link.setAttribute("type", prevType);
    };
  }, [href]);
}
